<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">Lista Negra</span></li>
      </ol>
    </div>
  </div>
</div>

<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Lista Negra</h3>
    </div>


    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Nombres:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Nombres y Apellidos</mat-label>
              <input matInput type="text" placeholder="Nombres y Apellidos" [(ngModel)]="filter.nombres" maxlength="80">
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Nro Documento Identidad:</label>
          <div class="col-md-2">
            <mat-form-field appearance="outline">
              <mat-label>Nro Documento Identidad</mat-label>
              <input matInput type="text" [(ngModel)]="filter.nroDocumento" name="nroDocumento" maxlength="15" />
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Compañía:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="filter.companias" [disabled]="listaCompanias.length == 1" multiple>
                <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                  {{ company.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="form-horizontal">
        <div class="form-group">
          <div class="col-sm-6 text-left">
            <a class="btn btn-naranja" mat-raised-button
              [routerLink]="['/listanegra', 'registrar']"><mat-icon>description</mat-icon> Añadir Persona</a>
            <!-- [routerLink]="['/solicitudes-engie/registrar']" -->
            <!-- <a class="btn btn-celeste" mat-raised-button [routerLink]="['/solicitudes-engie, 'exportar']">Exportar</a> -->
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table mat-table [dataSource]="model.items" class="table table-striped table-vcenter">
          <ng-container matColumnDef="nombres">
            <th mat-header-cell *matHeaderCellDef>Nombres</th>
            <td mat-cell *matCellDef="let element">{{ element.nombres }} {{ element.apellidoPaterno }}
              {{ element.apellidoMaterno }}</td>
          </ng-container>

          <ng-container matColumnDef="nroDocumentoIdentidad">
            <th mat-header-cell *matHeaderCellDef>Nro Documento Identidad</th>
            <td mat-cell *matCellDef="let element">{{ element.nroDocumentoIdentidad }}</td>
          </ng-container>

          <ng-container matColumnDef="compania">
            <th mat-header-cell *matHeaderCellDef>Compañía</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.compania }}</td>
          </ng-container>

          <ng-container matColumnDef="fecharegistro">
            <th mat-header-cell *matHeaderCellDef>Fecha Registro</th>
            <td mat-cell *matCellDef="let element">{{ element.fechaCreacion | date: "dd/MM/yyyy" }}</td>
          </ng-container>

          <ng-container matColumnDef="registradopor">
            <th mat-header-cell *matHeaderCellDef>Registrado Por</th>
            <td mat-cell *matCellDef="let element">{{ element.registradoPor }}</td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let element">
              <a mat-icon-button color="primary" aria-label="Eliminar" (click)="deletePersona(element)">
                <!-- (click)="openDialog(element)" -->
                <mat-icon>delete</mat-icon>
              </a>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>